import { FORM_ACTIONS } from './formValidation'
import { get } from '@bigyouth/base'
import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'
import getOffset from '../utils/getOffset'

export default {
  name: 'form',

  ui: {
    reset: '[js-form-reset]',
    'edit[]': '[js-form-edit]',
  },

  componentDidMount () {
    const formId = this.el.getAttribute('data-form-id')

    if (formId) {
      this.pipe = getPipe(formId)

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          const formDataNew = new FormData()

          for (const [key, value] of Object.entries(formData)) {
            formDataNew.append(key, value)
          }

          switch (action) {
            case FORM_ACTIONS.SUBMIT: {
              if (get('[js-form-error]')) {
                get('[js-form-error]').remove()
              }

              if (get('.form__success')) {
                get('.form__success').remove()
              }

              axios.post(this.props.url, formDataNew, {})
                .then(response => {
                  if (response.data.success) {
                    const successMessage = document.createElement('p')
                    successMessage.className = 'form__success'
                    successMessage.innerHTML = this.props.success

                    if (this.props.type === 'contact') {
                      gtag('event', 'formulaire-ok', { form_name: 'contact', form_type: 'contact' })
                    } else if (this.props.type === 'register') {
                      gtag('event', 'formulaire-ok', { form_name: 'register', form_type: 'register' })
                    } else if (this.props.type === 'newsletter') {
                      gtag('event', 'formulaire-ok', { form_name: 'newsletter', form_type: 'newsletter' })
                    }

                    if (this.props.type === 'contact' || this.props.type === 'register') {
                      window.scrollTo({
                        top: getOffset(get('#contact-form')) - 150,
                        left: 0,
                      })
                    }

                    if (this.props.type !== 'edit') {
                      this.el.parentNode.append(successMessage)
                      this.el.remove()
                    } else {
                      this.el.parentNode.prepend(successMessage)
                      successMessage.classList.add('mb-8')

                      this.el.querySelectorAll('[js-form-input-disabled]').forEach(input => {
                        input.setAttribute('disabled', '')
                      })

                      this.el.querySelectorAll('input[type="password"]').forEach(input => {
                        input.value = ''
                      })
                    }
                  }
                })
                .catch(e => {
                  if (e.response) {
                    const errorWrap = document.createElement('div')
                    errorWrap.classList.add('mt-4')
                    const error = document.createElement('div')
                    error.classList.add('form__error-big')
                    error.setAttribute('js-form-error', '')
                    error.innerHTML = e.response.data && e.response.data.message ? e.response.data.message : 'Erreur lors de la soumission'

                    errorWrap.append(error)

                    this.el.append(errorWrap)
                  }

                  if (this.props.type === 'contact') {
                    gtag('event', 'formulaire-nook', { form_name: 'contact', form_type: 'contact' })
                  } else if (this.props.type === 'register') {
                    gtag('event', 'formulaire-nook', { form_name: 'register', form_type: 'register' })
                  } else if (this.props.type === 'newsletter') {
                    gtag('event', 'formulaire-nook', { form_name: 'newsletter', form_type: 'newsletter' })
                  }
                })
            }
          }
        })
      }
    }

    if (this.ui.reset) {
      this.ui.reset.addEventListener('click', () => {
        this.el.reset()

        if (get('[js-form-error]')) {
          get('[js-form-error]').remove()
        }
      })
    }

    if (this.ui.edit) {
      this.ui.edit.forEach(button => {
        button.addEventListener('click', (e) => {
          const input = e.target.closest('.form__row').querySelector('input')
          const val = input.value
          input.removeAttribute('disabled')
          input.focus()

          // put cursor to the end
          input.value = ''
          input.value = val
        })
      })
    }
  },
}
